import React from 'react';

/**
 * Feature/benefit cards grid.
 *
 * Props:
 *   items - array of { icon, title, desc }
 */
const WhyUsGrid = ({ items = [] }) => {
  if (items.length === 0) return null;

  return (
    <div className="rr-why-grid">
      {items.map((item) => (
        <div key={item.title} className="rr-why-card">
          <div className="rr-why-card__icon">{item.icon}</div>
          <div className="rr-why-card__title">{item.title}</div>
          <div className="rr-why-card__desc">{item.desc}</div>
        </div>
      ))}
    </div>
  );
};

export default WhyUsGrid;
